/**
 * MessageTypingIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const MessageTypingIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M16 3H8c-3.85 0-7 3.15-7 7s3.15 7 7 7h.882l1.776 3.553c.293.585.783.921 1.342.921.56 0 1.049-.335 1.342-.922L15.118 17H16c3.85 0 7-3.15 7-7s-3.15-7-7-7m-9 8.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const MessageTypingIcon = makeIcon('MessageTypingIcon', MessageTypingIconSvg)
